import { render, staticRenderFns } from "./ConfirmDeleteHistory.vue?vue&type=template&id=ce56073a"
import script from "./ConfirmDeleteHistory.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports